import { t } from '../../i18n.es.js';
import React from 'react';
import { styled, SvgIcon } from '@teko/ui';
import { getTrackingData } from '@teko/tracking';
import { ListTile } from '../ListTile/ListTile.es.js';
import { Text } from '../../mobile/Text/Text.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const SearchSuggestion = styled.div`
  position: absolute;
  background: #fff;
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.1);
  padding: 0.5rem 0.8rem;
  display: ${(props) => props.show ? "block" : "none"};
`;
const StyledListTile = styled(ListTile)`
  border-radius: 8px;
`;
const StyledSearchTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 4px 0;
`;
const StyledRecommendedKeyword = styled.div`
  margin: 8px 0 4px;
`;
const ListTerm = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  column-gap: 8px;
  row-gap: 8px;
`;
const TermItem = styled.div`
  display: flex;
  align-items: center;
  height: 40px;
  line-height: 40px;
  padding: 0 8px;
  border-radius: 4px;
  border: 1px solid #e4e5f0;
  font-size: 13px;
  cursor: pointer;
  &:hover {
    background-color: #f5f5f5;
  }
`;
const StyledSearchIcon = styled(SvgIcon)`
  margin-right: 8px;
  min-width: 20px;
`;
const SearchSuggestions = ({
  suggestions,
  selected = null,
  onHoverItem,
  onClick,
  show,
  popularKeywords = [],
  showPopularKeywords = false
}) => {
  const renderRecommendedKeyword = () => {
    if (typeof window !== "undefined" && showPopularKeywords && popularKeywords.length > 0)
      return /* @__PURE__ */ React.createElement(StyledRecommendedKeyword, null, /* @__PURE__ */ React.createElement(StyledSearchTitle, null, /* @__PURE__ */ React.createElement(Text, {
        fontWeight: "500",
        textTransform: "uppercase",
        color: "#82869E"
      }, t("T\u1EEB kh\xF3a ph\u1ED5 bi\u1EBFn"))), /* @__PURE__ */ React.createElement(ListTerm, null, popularKeywords.map((term, index) => {
        return /* @__PURE__ */ React.createElement(TermItem, __spreadValues({
          onClick: () => onClick(term),
          key: `popularKeyword${index}`
        }, getTrackingData({
          isTrackContent: true,
          regionName: "popularKeyword",
          contentName: term,
          index
        })), /* @__PURE__ */ React.createElement(StyledSearchIcon, {
          name: "search",
          size: 20
        }), /* @__PURE__ */ React.createElement(Text, {
          maxLines: 1
        }, term));
      })));
  };
  return /* @__PURE__ */ React.createElement(SearchSuggestion, {
    show: show && (suggestions.length > 0 || popularKeywords.length > 0 && showPopularKeywords)
  }, suggestions.length > 0 && /* @__PURE__ */ React.createElement(React.Fragment, null, suggestions.every((s) => s.icon === "time-outline") && /* @__PURE__ */ React.createElement(StyledSearchTitle, null, /* @__PURE__ */ React.createElement(Text, {
    fontWeight: "500",
    textTransform: "uppercase",
    color: "#82869E"
  }, t("L\u1ECBch s\u1EED t\xECm ki\u1EBFm"))), suggestions.map((suggestionItem, index) => {
    const regionName = suggestionItem.icon === "time-outline" ? "recentlySearch" : "popularKeyword";
    return /* @__PURE__ */ React.createElement(StyledListTile, __spreadValues({
      selected: index === selected,
      key: `recentlySearch${index}`,
      leading: /* @__PURE__ */ React.createElement(SvgIcon, {
        name: suggestionItem.icon,
        size: 20
      }),
      title: suggestionItem.keyword,
      onClick: () => onClick(suggestionItem.keyword),
      onMouseEnter: () => onHoverItem(index),
      type: "search-suggestion"
    }, getTrackingData({
      isTrackContent: true,
      regionName,
      contentName: suggestionItem.keyword,
      index
    })));
  })), renderRecommendedKeyword());
};

export { SearchSuggestions };
